import React, {Component} from 'react';
import Avi from '../assets/profile.jpg';
// import editbutton from '../assets/edit-image.svg';
import loader from '../assets/loader.svg';
import {baseUrl} from './url';
import inputLoader from '../assets/input-loader.svg';
import { Link, withRouter } from 'react-router-dom';

class EditCaregiver extends Component{
    state = {
        bio: {},
        type: 'caregiver',
        first_name: '',
        last_name: '',
        alias: '',
        email: '',
        phone_no: '',
        prefix: '',
        aliasResponse: true,
        phone_noResponse: true,
        response: true,
        success: false,
    }
    componentDidMount(){
        this.fetchCaregiver();
    }
    fetchCaregiver = () => {
        let token = localStorage.getItem('access_token'),
            user_id = localStorage.getItem('user_id'),
            user_t = localStorage.getItem('user_type'),
            retries = 0;
        
        fetch(`${baseUrl}/admin/users/${user_t}/${user_id}`,{
            method: 'GET',
            headers: {
                'Authorization': token
            },
        })
        .then((response) => {
            const auth = response.headers.get('Authorization');
            localStorage.setItem('access_token', auth);
            return response.json();
        })
        .then((responseJson) => {
            const { bio } = responseJson.data;
            const { first, last } = bio.fullname;
            this.setState({
                bio,
                first_name: first,
                last_name: last,
                alias: bio.alias,
                email: bio.email,
                phone_no: bio.phone_no,
                prefix: bio.prefix,
                response: true
            })
        })
        .catch((error)=>{
            if (error === 401 && retries < 1){
                localStorage.getItem('access_token')
                .then(value => {
                    fetch(`${baseUrl}/token/refresh`,{
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': value
                        }
                    }).then(response => {
                        retries += 1;
                        if(response.status === 200){
                            localStorage.setItem('access_token', response.headers.get('Authorization'));
                            this.handleSubmit();
                        }
                        else{
                            alert('something went wrong please try again later');
                        }
                    })
                })
            }
			else if (error instanceof TypeError){
				console.log(error);
			}
            else{
                alert('something went wrong please try again later');
            }
        })
    }
    handleChange = (e) => {
        this.setState({ 
            [e.target.name]: e.target.value,
            [e.target.name + 'Error']: ''
        });
        if((e.target.name === 'alias' || e.target.name === 'phone_no') && e.target.value.length > 0){
            this.checkUnique(e.target.name, e.target.value);
        }
    }
    checkUnique = (item, value) => {
        if(item === 'alias'){
            this.setState({
                aliasResponse: false
            })
        }
        if(item === 'treatment_no'){
            this.setState({
                treatmentResponse: false
            })
        }
        if(item === 'phone_no'){
            this.setState({
                phone_noResponse: false
            })
        }
        const token = localStorage.getItem('access_token');
        fetch(`${baseUrl}/unique?item=${item}&value=${value}`,{
            method: 'GET',
            headers: {
                'Authorization': token
            }
        })
        .then((response) => {
            response.json()
            if(item === 'alias'){
                this.setState({
                    aliasResponse: true
                })
            }
            if(item === 'treatment_no'){
                this.setState({
                    treatmentResponse: true
                })
            }
            if(item === 'phone_no'){
                this.setState({
                    phone_noResponse: true
                })
            }
            if(response.status === 409){
                if(item === 'alias'){
                    this.setState({
                        aliasError: 'Alias is already in use.'
                    })
                    if(value === this.state.bio.alias){
                        this.setState({
                            aliasError: ''
                        })
                    }
                }
                else if(item === 'phone_no'){
                    this.setState({
                        phone_noError: 'Phone number is already in use.'
                    })
                    if(value === this.state.bio.phone_no){
                        this.setState({
                            phone_noError: ''
                        })
                    }
                }
                else if(item === 'treatment_no'){
                    this.setState({
                        treatment_noError: 'Treatment number already exists.',
                        treatmentResponse: true
                    })
                }
            }
        })
    }
    handleSubmit = (e) => {
        e.preventDefault();
        const {
            first_name,
            last_name,
            alias,
            email,
            phone_no,
            prefix,
            type,
            aliasError,
            phone_noError,
        } = this.state;

        if(!first_name){
            this.setState({
                first_nameError: 'This field should not be empty'
            })
        }
        if(!last_name){
            this.setState({
                last_nameError: 'This field should not be empty'
            })
        }
        if(!alias){
            this.setState({
                aliasError: 'This field should not be empty'
            })
        }
        if(!phone_no){
            this.setState({
                phone_noError: 'This field should not be empty'
            })
        }
        if(!email){
            this.setState({
                emailError: 'This field should not be empty'
            })
        }
        if(!prefix){
            this.setState({
                prefixError: 'Please select a title'
            })
        }
        if(type && first_name && last_name && alias && phone_no && email && !phone_noError && !aliasError){
            this.setState({
                response: false
            })
            let retries = 0;
            let token = localStorage.getItem('access_token'),
                user_id = localStorage.getItem('user_id');
            fetch(`${baseUrl}/admin/users/update/${user_id}`,{
                method: 'PUT',
                headers:{
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                body: JSON.stringify({
                    "type": type,
                    "first_name": first_name,
                    "last_name": last_name,
                    "alias": alias,
                    "phone_no": phone_no,
                    "email": email,
                    "prefix": prefix,
                })
            })
            .then((response) => {
                const auth = response.headers.get('Authorization');
                localStorage.setItem('access_token', auth);
                return response.json();
            })
            .then((responseJson) => {
                this.setState({
                    response: true
                })
                if (responseJson.hasOwnProperty('_meta')){
                    if(responseJson._meta._status === 202){
                        this.setState({
                            success: true,
                            message: responseJson.message
                        })
                    }
                 }
            })
            .catch((error)=>{
                if (error === 401 && retries < 1){
                    localStorage.getItem('access_token')
                    .then(value => {
                        fetch(`${baseUrl}/token/refresh'`,{
                            headers: {
                                'Accept': 'application/json',
                                'Authorization': value
                            }
                        }).then(response => {
                            retries += 1;
                            if(response.status === 200){
                                localStorage.setItem('access_token', response.headers.get('Authorization'));
                                this.handleSubmit();
                            }
                            else{
                                alert('something went wrong please try again later');
                            }
                        })
                    })
                }
                else{
                    alert('something went wrong please try again later');
                }
            })
        }
    }
    redirect = () => {
        this.props.history.push('/caregiver');
    }
    render(){
        const { first_name, last_name, alias, email, phone_no, phone_noResponse, aliasResponse, success, response, bio } = this.state;
        return(
            <React.Fragment>
                {
                    Object.keys(bio).length === 0 &&
                    <div className="loader">
                        <img src={loader} alt=""/>
                    </div>
                }
                {
                    Object.keys(bio).length > 0 &&
                    <div className="edit-caregiver">
                        <div className="row">
                            <div className="col-sm-8">
                            {
                                !success &&
                                <form>
                                    <div className="edit-div">
                                        <h4>Basic Information</h4>
                                        <div className="row">
                                            <div className="col-sm-2">
                                                <div className="img-div">
                                                    <img src={Avi} alt=""/>
                                                    {/* <img src={editbutton} alt="" className="edit-image"/> */}
                                                </div>
                                            </div>
                                            <div className="col-sm-10">
                                                <div className="row">
                                                        <div className="col-sm-6">
                                                            <label>
                                                                First Name
                                                                <input 
                                                                    type="text"
                                                                    name="first_name" 
                                                                    onChange={this.handleChange}
                                                                    value={first_name}
                                                                    className={this.state.first_nameError && 'error-input'}/>
                                                                    <span className="error-text">{this.state.first_nameError}</span>
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <label>
                                                                Last Name
                                                                <input
                                                                    type="text"
                                                                    name="last_name"
                                                                    onChange={this.handleChange}
                                                                    value={last_name}
                                                                    className={this.state.last_nameError && 'error-input'}/>
                                                                    <span className="error-text">{this.state.last_nameError}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <label>
                                                                Alias
                                                                <input
                                                                    type="text"
                                                                    name="alias"
                                                                    onChange={this.handleChange}
                                                                    value={alias}
                                                                    className={this.state.aliasError && 'error-input'}/>
                                                                {!aliasResponse && <img src={inputLoader} alt='' className='input-loader'/>}
                                                                <span className="error-text">{this.state.aliasError}</span>
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <label>
                                                                Title
                                                                <select 
                                                                    name="prefix" 
                                                                    className={this.state.prefixError && 'error-input'} 
                                                                    onChange={this.handleChange}
                                                                    value={this.state.prefix}>
                                                                    <option value="dr">Dr</option>
                                                                    <option value="mr">Mr</option>
                                                                    <option value="mrs">Mrs</option>
                                                                    <option value="ms">Ms</option>
                                                                </select>
                                                                <span className="error-text">{this.state.prefixError}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <label>
                                                                Phone Number
                                                                <input
                                                                    type="number"
                                                                    name="phone_no"
                                                                    onChange={this.handleChange} 
                                                                    value={phone_no}
                                                                    className={this.state.phone_noError && 'error-input'}/>
                                                                {!phone_noResponse && <img src={inputLoader} alt='' className='input-loader'/>}
                                                                <span className="error-text">{this.state.phone_noError}</span>
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <label>
                                                                Email
                                                                <input
                                                                    type="email"
                                                                    name="email"
                                                                    onChange={this.handleChange}
                                                                    value={email}
                                                                    className={this.state.emailError && 'error-input'}/>
                                                                    <span className="error-text">{this.state.emailError}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="edit-div buttons">
                                        <div className="button-div">
                                            <Link to='/caregiver'>
                                                <button className="cancel-btn">Cancel</button>
                                            </Link>
                                            <button onClick={this.handleSubmit}>
                                                Save Changes
                                                {
                                                    !response &&
                                                    <i className="fa fa-spinner fa-pulse fa-fw" />
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            }
                            {
                                success &&
                                <div className="edit-div">
                                    <div className="check">
                                        <div className="svg-div">
                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                                <circle className="path circle" fill="none" stroke="#14DA9E" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                                                <polyline className="path check" fill="none" stroke="#14DA9E" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                                            </svg>
                                        </div>
                                        <p>{this.state.message}</p>
                                        <button onClick={this.redirect}>Okay</button>
                                    </div>
                                </div>
                            }
                            </div>
                        </div>
                    </div>
                }
            </React.Fragment>
        )
    }
}

export default withRouter(EditCaregiver);


// WEBPACK FOOTER //
// ./src/components/EditCaregiver.js